module.exports = __webpack_public_path__ + "media/images/cross-mark-d1627fb8.svg";